import InterBoldWoff2 from '../../assets/fonts/Inter/Inter-Bold.woff2';
// Fonts imports
import InterLightWoff2 from '../../assets/fonts/Inter/Inter-Light.woff2';
import InterMediumWoff2 from '../../assets/fonts/Inter/Inter-Medium.woff2';
import InterRegularWoff2 from '../../assets/fonts/Inter/Inter-Regular.woff2';
import InterSemiBoldWoff2 from '../../assets/fonts/Inter/Inter-SemiBold.woff2';

export const GLOBALS = {
    MuiCssBaseline: {
        styleOverrides: `      
    @font-face {
        font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 300;
          src: local('Inter'), local('Inter-Light'), url(${InterLightWoff2}) format('woff2');
    }
    
    @font-face {
        font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Inter'), local('Inter-Regular'), url(${InterRegularWoff2}) format('woff2');
    }
    
    @font-face {
        font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('Inter'), local('Inter-Medium'), url(${InterMediumWoff2}) format('woff2');
    }
    
    @font-face {
        font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 600;
          src: local('Inter'), local('Inter-Medium'), url(${InterSemiBoldWoff2}) format('woff2');
    }
    
    @font-face {
        font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('Inter'), local('Inter-Medium'), url(${InterBoldWoff2}) format('woff2');
    }
    `,
    },
};
